import Hero from '@/components/landing/Hero';
import Features from '@/components/landing/Features';
import AppShowcase from '@/components/landing/AppShowcase';
import EnterpriseFeature from '@/components/landing/EnterpriseFeature';
import Footer from '@/components/landing/Footer';
import LanguageSwitcher from '@/components/landing/LanguageSwitcher';

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-gray-900" data-theme="light">
      <LanguageSwitcher />
      <Hero />
      <Features />
      <AppShowcase />
      <EnterpriseFeature />
      <Footer />
    </div>
  );
}
